import { useState } from "react";
import { ChevronDown, HelpCircle } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const faqs = [
  {
    question: "¿Necesito internet para usar QvaPOS?",
    answer:
      "QvaPOS funciona tanto con conexión a internet como sin ella. Puedes realizar ventas y gestionar tu inventario offline, y los datos se sincronizarán automáticamente cuando recuperes la conexión.",
  },
  {
    question: "¿Cuánto tiempo toma la instalación?",
    answer:
      "La instalación y configuración inicial toma aproximadamente 1-2 horas. Nuestro equipo te guiará en todo el proceso y te capacitará para que puedas usar el sistema de inmediato.",
  },
  {
    question: "¿Puedo usar QvaPOS en varios dispositivos?",
    answer:
      "Sí, puedes acceder a QvaPOS desde múltiples dispositivos. El sistema está diseñado para trabajar en computadoras, tablets y teléfonos móviles.",
  },
  {
    question: "¿Qué métodos de pago acepta QvaPOS?",
    answer:
      "QvaPOS te permite registrar ventas en efectivo, transferencias bancarias y otros métodos de pago. Puedes configurar los métodos según las necesidades de tu negocio.",
  },
  {
    question: "¿Cómo puedo ver los reportes de mi negocio?",
    answer:
      "El sistema genera reportes de ventas, inventario y ganancias. El nivel de detalle y el tipo de reportes a los que tienes acceso dependerá del plan que hayas contratado. Puedes acceder a ellos desde cualquier dispositivo.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section
      id="faq"
      className="py-16 sm:py-20 lg:py-24 bg-white dark:bg-slate-900"
    >
      <div className="container px-4 mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-sm font-bold mb-6">
            <HelpCircle className="w-4 h-4" />
            <span>Preguntas Frecuentes</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black mb-4 sm:mb-6 tracking-tight leading-tight font-display text-slate-900 dark:text-white">
            ¿Tienes dudas?
          </h2>
          <p className="text-base sm:text-lg text-slate-600 dark:text-slate-400 leading-relaxed">
            Encuentra respuestas a las preguntas más comunes sobre QvaPOS.
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3 sm:space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-slate-50 dark:bg-slate-800 rounded-2xl overflow-hidden border border-slate-100 dark:border-slate-700"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-4 sm:p-6 text-left gap-3"
              >
                <span className="font-bold text-sm sm:text-base text-slate-900 dark:text-white">
                  {faq.question}
                </span>
                <motion.div
                  animate={{ rotate: openIndex === index ? 180 : 0 }}
                  transition={{ duration: 0.2 }}
                  className="flex-shrink-0"
                >
                  <ChevronDown className="w-4 h-4 sm:w-5 sm:h-5 text-slate-500" />
                </motion.div>
              </button>
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    <div className="px-4 pb-4 sm:px-6 sm:pb-6 text-sm sm:text-base text-slate-600 dark:text-slate-400 leading-relaxed">
                      {faq.answer}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
